export type RenderFilters = { clientId?: number; invoiceId?: number; startDate?: string; endDate?: string; invoicedOnly?: boolean };
export type RenderOperation = {
  contractVersion: "reports-render-authorization-v1"; reportFamily: "v2" | "v3";
  reportKey?: string; definitionId?: string; revision?: string; output: "pdf" | "excel"; filters: RenderFilters;
};
export type RenderContext = {
  renderOperation: RenderOperation;
  renderProfile?: { reportKey: string; schemaVersion: string };
};

export function buildRenderContext(meta: Record<string, unknown>, output: "pdf" | "excel", family: "v2" | "v3"): RenderContext {
  const reportKey = String(meta.reportId || "");
  const filters: RenderFilters = {};
  const invoiceId = Number(meta.invoiceId || meta.outstandingId || 0);
  if (family === "v2" && ["invoice", "outstanding"].includes(reportKey) && invoiceId > 0) {
    filters.invoiceId = invoiceId;
  } else {
    if (typeof meta.startDate === "string") filters.startDate = meta.startDate;
    if (typeof meta.endDate === "string") filters.endDate = meta.endDate;
    if ((family === "v3" || ["invoice", "landmanStatus", "timeEntryDetails"].includes(reportKey)) && Number(meta.clientId) > 0) filters.clientId = Number(meta.clientId);
    if (family === "v3" && invoiceId > 0) filters.invoiceId = invoiceId;
    if (["invoice", "outstanding"].includes(reportKey)) filters.invoiceId = invoiceId;
  }
  if (family === "v2") {
    return { renderOperation: { contractVersion: "reports-render-authorization-v1", reportFamily: family, reportKey: reportKey === "landmanPaymentSummary" ? "landman" : reportKey, output, filters } };
  }
  if (typeof meta.definitionId !== "string" || !meta.definitionId || typeof meta.revision !== "string" || !meta.revision.trim()) {
    throw new Error("Refresh the saved report before exporting. Its current saved revision is required.");
  }
  if (meta.invoicedOnly !== undefined) {
    if (typeof meta.invoicedOnly !== "boolean") throw new Error("Refresh the report before exporting. Its effective Include setting is invalid.");
    filters.invoicedOnly = meta.invoicedOnly;
  }
  return {
    renderOperation: { contractVersion: "reports-render-authorization-v1", reportFamily: family, definitionId: meta.definitionId, revision: meta.revision, output, filters },
    renderProfile: { reportKey, schemaVersion: typeof meta.schemaVersion === "string" ? meta.schemaVersion : "reports-v3.0" },
  };
}
